import { getI18nFromGeneral } from 'src/tools/tools';
import { EDiscount } from 'src/types/common/discount';
import { EnumStatus } from 'src/types/common/common';
const discountTypeToI18n = {
  [EDiscount.DirectDiscount]: getI18nFromGeneral(
    'general.sider.directDiscounts',
  ),
  [EDiscount.FlashSale]: getI18nFromGeneral('general.sider.flashSale'),
  [EDiscount.GiftPurchase]: getI18nFromGeneral('general.sider.giftPurchase'),
  [EDiscount.SubscriptionBuy]: getI18nFromGeneral(
    'general.sider.subscriptionBuy',
  ),
  [EDiscount.Voucher]: getI18nFromGeneral('general.sider.voucher'),
};

const generatePromotions = (availableDiscounts, getI18n) => {
  const availablePromotions: any = Object.keys(availableDiscounts).reduce(
    (pre: any, now: any) => {
      const kInI18n = discountTypeToI18n[now];
      const options = availableDiscounts[now] || [];
      const active = options.filter((i) => i.status === EnumStatus.Active);
      const issued = options.filter((i) => i.status === EnumStatus.Issued);
      const scheduled = options.filter(
        (i) => i.status === EnumStatus.Scheduled,
      );

      const archived = options.filter((i) => i.status === EnumStatus.Archived);
      const draft = options.filter((i) => i.status === EnumStatus.Draft);
      const expired = options.filter((i) => i.status === EnumStatus.Expired);
      const hasSection =
        active.length > 0 ||
        archived.length > 0 ||
        draft.length > 0 ||
        expired.length > 0;
      if (!hasSection) {
        return pre;
      } else {
        const s = {
          title: kInI18n,
          checkable: false,
          selectable: false,
          key: now,
          value: now,
          children: [
            ...(active.length > 0
              ? [
                  {
                    title: getI18n('general.status.active'),
                    checkable: false,
                    selectable: false,
                    key: `${now}-${EnumStatus.Active}`,
                    value: `${now}-${EnumStatus.Active}`,
                    children: active.map((i) => {
                      return {
                        title: i.name,
                        value: i.uuid,
                        key: i.uuid,
                        selectable: true,
                      };
                    }),
                  },
                ]
              : []),
            ...(archived.length > 0
              ? [
                  {
                    title: getI18n('general.status.archived'),
                    checkable: false,
                    selectable: false,
                    key: `${now}-${EnumStatus.Archived}`,
                    value: `${now}-${EnumStatus.Archived}`,
                    children: archived.map((i) => {
                      return {
                        title: i.name,
                        value: i.uuid,
                        key: i.uuid,
                        selectable: true,
                      };
                    }),
                  },
                ]
              : []),
            ...(draft.length > 0
              ? [
                  {
                    title: getI18n('general.status.draft'),
                    checkable: false,
                    selectable: false,
                    key: `${now}-${EnumStatus.Draft}`,
                    value: `${now}-${EnumStatus.Draft}`,
                    children: draft.map((i) => {
                      return {
                        title: i.name,
                        value: i.uuid,
                        key: i.uuid,
                        selectable: true,
                      };
                    }),
                  },
                ]
              : []),
            ...(expired.length > 0
              ? [
                  {
                    title: getI18n('general.status.expired'),
                    checkable: false,
                    selectable: false,
                    key: `${now}-${EnumStatus.Expired}`,
                    value: `${now}-${EnumStatus.Expired}`,
                    children: expired.map((i) => {
                      return {
                        title: i.name,
                        value: i.uuid,
                        key: i.uuid,
                        selectable: true,
                      };
                    }),
                  },
                ]
              : []),
            ...(issued.length > 0
              ? [
                  {
                    title: getI18n('general.status.issued'),
                    checkable: false,
                    selectable: false,
                    key: `${now}-${EnumStatus.Issued}`,
                    value: `${now}-${EnumStatus.Issued}`,
                    children: issued.map((i) => {
                      return {
                        title: i.name,
                        value: i.uuid,
                        key: i.uuid,
                        selectable: true,
                      };
                    }),
                  },
                ]
              : []),
            ...(scheduled.length > 0
              ? [
                  {
                    title: getI18n('general.status.scheduled'),
                    checkable: false,
                    selectable: false,
                    key: `${now}-${EnumStatus.Scheduled}`,
                    value: `${now}-${EnumStatus.Scheduled}`,
                    children: scheduled.map((i) => {
                      return {
                        title: i.name,
                        value: i.uuid,
                        key: i.uuid,
                        selectable: true,
                      };
                    }),
                  },
                ]
              : []),
          ],
        };

        return [...pre, s];
      }
      // return [...pre, ...(now || [])];
    },
    [],
  );
  return availablePromotions;
};
export { generatePromotions };
